import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import InlineSVG from 'svg-inline-react';
import { Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledIcon = styled(function (props) {
  return /*#__PURE__*/_jsx(InlineSVG, _objectSpread({
    raw: true
  }, props));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n\n  .fill {\n    fill: currentColor;\n  }\n\n  .stroke {\n    stroke: currentColor;\n  }\n\n  width: ", ";\n  height: ", ";\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return typeof props.width === 'string' ? props.width : pxToRem(props.width || 20);
}, function (props) {
  return typeof props.height === 'string' ? props.height : pxToRem(props.height || 20);
}, function (props) {
  return typeof props.width === 'string' ? props.width : pxToRem(props.width || 20);
}, function (props) {
  return typeof props.height === 'string' ? props.height : pxToRem(props.height || 20);
});
var RightAlignedIcon = styled(Box)(function (_ref) {
  var theme = _ref.theme,
    userScreenWidth = _ref.userScreenWidth;
  var visibleWidthPercentage;
  if (userScreenWidth >= 1030) {
    // This example assumes you want to start revealing more of the icon starting at 1030px,
    // and fully reveal by 1920px screen width. Adjust these numbers as needed.
    var minScreenWidth = 1030;
    var maxScreenWidth = 1920; // Adjust based on when you want the icon fully revealed
    // Calculate visible width percentage
    visibleWidthPercentage = Math.min(100, (userScreenWidth - minScreenWidth) / (maxScreenWidth - minScreenWidth) * 100);
  } else {
    visibleWidthPercentage = 0; // Hide if below 1030px
  }
  return {
    position: 'absolute',
    right: 0,
    top: '50%',
    // Ensure the left part is always visible and reveal towards the right
    clipPath: "polygon(0 0, ".concat(visibleWidthPercentage, "% 0%, ").concat(visibleWidthPercentage, "% 100%, 0 100%)"),
    display: userScreenWidth >= 1030 ? 'block' : 'none'
  };
});
export { StyledIcon, RightAlignedIcon };